export const CONFIGS_NAME = {
  DEFAULT: 'default',
  TAMGA: 'tamga',
  OVERSIGHT: 'oversight',
};
